import styled from 'styled-components';
import { colors, spacing, breakpoints } from '../../constants/theme';

// Base container styles
export const Container = styled.div`
  min-height: calc(100vh - 48px);
  background: ${colors.background.primary};
  color: ${colors.text.primary};
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const FlexContainer = styled.div<{
  direction?: 'row' | 'column';
  align?: 'flex-start' | 'center' | 'flex-end' | 'stretch';
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around';
  gap?: string;
  wrap?: boolean;
}>`
  display: flex;
  flex-direction: ${props => props.direction || 'row'};
  align-items: ${props => props.align || 'flex-start'};
  justify-content: ${props => props.justify || 'flex-start'};
  gap: ${props => props.gap || spacing.md};
  flex-wrap: ${props => props.wrap ? 'wrap' : 'nowrap'};
`;

export const GridContainer = styled.div<{
  columns?: string;
  gap?: string;
  minWidth?: string;
}>`
  display: grid;
  grid-template-columns: ${props => props.columns || `repeat(auto-fill, minmax(${props.minWidth || '320px'}, 1fr))`};
  gap: ${props => props.gap || spacing.lg};
`;

export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${spacing.xxl};

  @media (max-width: ${breakpoints.tablet}) {
    padding: ${spacing.lg} ${spacing.md};
    justify-content: flex-start;
    min-height: auto;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: ${spacing.md};
  }
`;

export const ContentArea = styled.main`
  flex: 1;
  padding: ${spacing.md} 0;
  overflow-y: auto;
`;

export const ContentPadding = styled.div`
  padding: ${spacing.md};
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: ${breakpoints.tablet}) {
    padding: ${spacing.sm};
  }
  
  @media (max-width: ${breakpoints.mobile}) {
    padding: ${spacing.xs} ${spacing.sm};
  }
`;

export const PageHeader = styled.header`
  text-align: center;
  margin-bottom: ${spacing.xxl};
  padding: ${spacing.xl} 0;
`;

export const Section = styled.section<{ spacing?: 'sm' | 'md' | 'lg' | 'xl' }>`
  margin-bottom: ${props => {
    switch (props.spacing) {
      case 'sm': return spacing.md;
      case 'md': return spacing.lg;
      case 'lg': return spacing.xl;
      case 'xl': return spacing.xxl;
      default: return spacing.xl;
    }
  }};
`;
